import { Container } from '@elotech/components';

export const SemAcessoModulo = () => (
  <Container breadcrumb>
    <div className="alert alert-warning">
      <strong>Entidade sem acesso ao módulo.</strong>
      <p>Você não possui acesso a este módulo para a entidade selecionada.</p>
    </div>
  </Container>
);
